import {
    apiRequest,
    PromotionPeriodList,
    PromotionPeriodDetail,
    prosesPegawai,
    downloadDraftSK,
    exportExcelUsulan,
    inputSK,
    createSKCollective,
    listSKCollective,
    downloadSKCollective,
    deleteSKCollective,
    generatePegawai,
    HDDownloadSP
} from "../../../../../services/adapters/kepegawaian/hukdisService"

class IndexRepository {

    fetchAwardList = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchProcess = async (query) => {
        return await apiRequest("post", prosesPegawai, {
            body: query
        }, true)
    }
    
    fetchGenerate = async (query) => {
        return await apiRequest("post", generatePegawai, {
            body: query
        }, true)
    }
    
    fetchDownloadDraftSK = async (query) => {
        return await apiRequest("get", downloadDraftSK, {
            params: query
        }, true)
    }
    
    fetchExportUsulan = async (query) => {
        return await apiRequest("get", exportExcelUsulan, {
            params: query
        }, true)
    }

    fetchInputSK = async (query) => {
        return await apiRequest("post", inputSK, {
            body: query
        }, true)
    }

    fetchCreateSKC = async (query) => {
        return await apiRequest("post", createSKCollective, {
            body: query
        }, true)
    }

    fetchListSKC = async (query) => {
        return await apiRequest("get", listSKCollective, {
            params: query
        }, true)
    }

    fetchDownloadSKC = async (query) => {
        return await apiRequest("get", downloadSKCollective, {
            params: query
        }, true)
    }
    fetchDeleteSKC = async (query) => {
        return await apiRequest("get", deleteSKCollective, {
            params: query
        }, true)
    }
    fetchDownloadSP = async (query) => {
        return await apiRequest("get", HDDownloadSP, {
            params: query
        }, true)
    }

}

export default IndexRepository;